module.exports = __webpack_public_path__ + "static/avatar-667beacd2b3364bddf56f4db010e73e7.jpg";